var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 7.49992H4.16732M15.834 7.49992H16.6673M7.50065 7.49992H8.33398M11.6673 7.49992H12.5007M3.33398 4.99992C3.33398 4.55789 3.50958 4.13397 3.82214 3.82141C4.1347 3.50885 4.55862 3.33325 5.00065 3.33325H15.0007C15.4427 3.33325 15.8666 3.50885 16.1792 3.82141C16.4917 4.13397 16.6673 4.55789 16.6673 4.99992V14.9999C16.6673 15.4419 16.4917 15.8659 16.1792 16.1784C15.8666 16.491 15.4427 16.6666 15.0007 16.6666H5.00065C4.55862 16.6666 4.1347 16.491 3.82214 16.1784C3.50958 15.8659 3.33398 15.4419 3.33398 14.9999V4.99992Z",
    stroke: "#6B7280",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.dc131f58f3bb1c1a508b6686d64f24ef.svg";
export { ForwardRef as ReactComponent };